import {AccessoryModel} from "../../asset/accessory.model";
import {standaloneAccessoryModelListFactory} from "../../asset/standalone-accessory.model";

export interface RelocateAssetBundleModel {
  id?: string;
  type?: "asset" | "accessory" | "";
  deviceKey?: string;
  product?: string;
  productDescription?: string;
  productNumber?: string;
  serialNumber?: string;
  standaloneAccessories?: AccessoryModel[];
}

export function relocateAssetBundleModelFactory(json?: any): RelocateAssetBundleModel {
  json = json || {};

  return {
    id: json.id || "",
    type: json.type || "",
    deviceKey: json.deviceKey || "",
    product: json.product || "",
    productDescription: json.productDescription || "",
    productNumber: json.productNumber || "",
    serialNumber: json.serialNumber || "",
    standaloneAccessories: standaloneAccessoryModelListFactory(json.standaloneAccessories),
  } as RelocateAssetBundleModel;
}

export function relocateAssetBundleModelListFactory(json?: any): RelocateAssetBundleModel[] {
  return Array.from(json || []).map(it => relocateAssetBundleModelFactory(it));
}
